import PouchDB from "pouchdb";
import { DatabaseIdentifier } from "./manager";
import { useCallback, useEffect, useState } from "react";
import { useCurrentDatabaseManager } from "./useDatabases";
import { useStableValue } from "../useStableValue";
import _ from "lodash";
import { PouchOptions } from "./common";

interface PouchGetReturn<T> {
  data: (T & PouchDB.Core.IdMeta & PouchDB.Core.GetMeta) | null;
  loading: boolean;
  error: unknown | null;
}

export function usePouchGet<T>(
  dependencies: DatabaseIdentifier[],
  database: PouchDB.Database<T> | undefined,
  id?: PouchDB.Core.DocumentId,
  options?: PouchOptions
): PouchGetReturn<T> {
  const [data, setData] = useState<(T & PouchDB.Core.IdMeta & PouchDB.Core.GetMeta) | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown | null>(null);

  const mngr = useCurrentDatabaseManager();

  const options_ = useStableValue(options);

  const load = useCallback(async () => {
    if (options_?.enabled === false) {
      return;
    }
    if (database && id) {
      setLoading(true);
      setError(null);
      try {
        console.log("[POUCH GET]", database.name, id);
        const resp = await database.get(id);
        setData((d) => (_.isEqual(d, resp) ? d : resp));
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    } else {
      setData(null);
      setLoading(false);
      setError(null);
    }
  }, [database, id, options_]);

  useEffect(() => {
    load().then(() => {});
  }, [load]);
  useEffect(() => {
    mngr?.registerQuery(dependencies, load);
    return () => mngr?.unregisterQuery(dependencies, load);
  }, [mngr, load, dependencies]);

  return { data, loading, error };
}
